import {
  Button,
  Description,
  Dialog,
  Error,
  Form,
  Header,
  Illustration,
  Input,
  ValidationStates
} from '@opengov/component-library/dist';
import { IReportLocale } from '@opengov/reporting-app/application/common/locale';
import { ISavedViewTitleAndDescription } from '@opengov/reporting-app/application/common/modals/components/SavedViewCreatingModal/SavedViewCreatingModal';

import { ISavedView } from '@opengov/reporting-types';
import React, { useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import styles from './SavedViewDeletingDialog.scss';

export interface ISavedViewDeletingModal {
  reportLocaleText: IReportLocale;
  savedView: ISavedView;
  onClose(): void;
  onDelete(savedView: ISavedViewTitleAndDescription, navigate?: NavigateFunction): void;
}

export const SavedViewDeletingDialog = (props: ISavedViewDeletingModal) => {
  const [confirmation, setConfirmation] = useState('');
  const [validationStatus, setValidationStatus] = useState(ValidationStates.None);
  const navigate = useNavigate();

  const handleConfirmationChange = (confirmation: string) => {
    if (confirmation.trim().length > 0 && confirmation === props.reportLocaleText.delete.confirmString) {
      setConfirmation(confirmation);
      setValidationStatus(ValidationStates.Success);
    } else {
      setConfirmation(confirmation);
      setValidationStatus(ValidationStates.Error);
    }
  };

  const handleDelete = () => {
    props.onDelete(props.savedView, navigate);
  };

  const {
    onClose,
    reportLocaleText: {
      cancel,
      delete: { label, confirmString },
      savedView: {
        modal: { deleteTitle, deleteBody1, deleteBody2, deleteConfirmationLabel, deleteHelper }
      }
    }
  } = props;

  return (
    <Dialog.Destructive onClose={onClose}>
      <div className={styles.borders}>
        <div>
          <Illustration illustration="destruction" />
        </div>
        <div>
          <div className={styles.section}>
            <Header variant="h2">{deleteTitle}</Header>
            <Description>{deleteBody1}</Description>
            <Description>{deleteBody2}</Description>
          </div>
          <div className={styles.section}>
            <Form.Item required={true} label={deleteConfirmationLabel({ deleteConfirm: confirmString })}>
              <Input.Text.Default
                onChange={handleConfirmationChange}
                value={confirmation}
                dataTest="savedViewConfirmationInput"
                validationState={validationStatus}
              />
              {validationStatus === ValidationStates.Error && (
                <Error dataTest="errorStateMessage">{deleteHelper({ deleteConfirm: confirmString })}</Error>
              )}
            </Form.Item>
          </div>
          <div className={styles.section}>
            <div className={styles.buttons}>
              <Button title={cancel} onClick={onClose} dataTest="cancelDeleteSavedView">
                {cancel}
              </Button>

              <Button
                variant="destructive"
                onClick={handleDelete}
                disabled={validationStatus !== ValidationStates.Success}
                dataTest="delete-saved-view-confirmation-button"
              >
                {label}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Dialog.Destructive>
  );
};
